import { Grid, IconButton } from '@mui/material'

import CloudflareImage from '@ecm/ui/element/CloudflareImage'

import appStoreBadge from '/public/images/icon/app-store-badge.svg'
import googlePlayBadge from '/public/images/icon/google-play-badge.svg'

type MobileAppButtonsProps = React.ComponentProps<typeof Grid>

const MobileAppButtons = ({ ...props }: MobileAppButtonsProps) => (
  <Grid container mt="2.5em" {...props}>
    <IconButton
      aria-label="app-store-badge"
      rel="noopener nofollow"
      target="_blank"
      href="https://apps.apple.com/app/apple-store/id1484077329?pt=119702745&ct=website_footer&mt=8"
      sx={{ p: 0 }}
    >
      <CloudflareImage src={appStoreBadge} width={120} />
    </IconButton>
    <IconButton
      aria-label="google-play-badge"
      rel="noopener nofollow"
      target="_blank"
      href="https://play.google.com/store/apps/details?id=io.delivered.ecm&hl=en&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
      sx={{ ml: { sm: '1.5em', xs: '0.5em' }, p: 0 }}
    >
      <CloudflareImage src={googlePlayBadge} width={137} height={40} />
    </IconButton>
  </Grid>
)

export default MobileAppButtons
